import { Component, Input, OnInit } from '@angular/core';

import { INivelesPromo, IPromosEcommerce } from '../../../../private/shared/models/productos';

@Component({
  selector: 'app-promo-status',
  templateUrl: './promo-status.component.html',
  styleUrls: ['./promo-status.component.scss'],
})
export class PromoStatusComponent implements OnInit {

  @Input() exchange = 0;
  @Input() isCheck = false;
  @Input() promo: IPromosEcommerce;
  @Input() Niveles: INivelesPromo[] = [];

  constructor() { }

  ngOnInit() {}

  /** Avance de los niveles de dinamica */
  public advanceLevel = () => this.Niveles.filter(n => n.Maximo === n.Minimo);

}
